module.exports = __webpack_public_path__ + "img/partner with us.1d2acd20.png";